import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGarage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5279 2C17.043 2 18.428 2.85601 19.1056 4.21115L21.3666 8.73313C21.7831 9.56626 22 10.4849 22 11.4164V20C22 21.1046 21.1046 22 20 22C18.8954 22 18 21.1046 18 20V18H6V20C6 21.1046 5.10457 22 4 22C2.89543 22 2 21.1046 2 20V11.4164C2 10.4849 2.21687 9.56626 2.63344 8.73313L4.89443 4.21115C5.572 2.85601 6.95705 2 8.47214 2H15.5279ZM19 13H17C16.4477 13 16 13.4477 16 14C16 14.5128 16.386 14.9355 16.8834 14.9933L17 15H19C19.5523 15 20 14.5523 20 14C20 13.4872 19.614 13.0645 19.1166 13.0067L19 13ZM7 13H5C4.44772 13 4 13.4477 4 14C4 14.5128 4.38604 14.9355 4.88338 14.9933L5 15H7C7.55228 15 8 14.5523 8 14C8 13.4872 7.61396 13.0645 7.11662 13.0067L7 13ZM15.7639 4H8.23607C7.53263 4 6.88526 4.36904 6.52512 4.96426L6.44721 5.10557L4 10H20L17.5528 5.10557C17.214 4.428 16.5215 4 15.7639 4Z",
		fill: "currentColor"
	})
});
export default SvgGarage;
